module.exports = __webpack_public_path__ + "static/about.6517ce96.svg";